"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiSelect = _interopRequireDefault(require("@tencent/spaui-select"));

var _info = _interopRequireDefault(require("./info"));

var _autocomplete_compact_props = _interopRequireDefault(require("./autocomplete_compact_props"));

var _autocomplete_props = require("./autocomplete_props");

var _push_data = require("./utils/push_data");

var _classname_map = _interopRequireDefault(require("./config/classname_map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var AutoComplete =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(AutoComplete, _PureComponent);

  function AutoComplete(props) {
    var _this;

    _classCallCheck(this, AutoComplete);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AutoComplete).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var _compactProps = (0, _autocomplete_compact_props["default"])(_this.props),
          onChange = _compactProps.onChange,
          data = _compactProps.data,
          multiple = _compactProps.multiple,
          delimiter = _compactProps.delimiter,
          _compactProps$fieldNa = _compactProps.fieldNames,
          fieldNames = _compactProps$fieldNa === void 0 ? {} : _compactProps$fieldNa;

      var _fieldNames$valueFiel = fieldNames.valueFieldName,
          valueFieldName = _fieldNames$valueFiel === void 0 ? 'value' : _fieldNames$valueFiel;
      var value = event.target.value || '';
      var valueData = []; // 获取value对应的数据

      (multiple ? value.split(delimiter) : [value]).map(function (valueItem) {
        data.map(function (dataItem) {
          var item = '';

          if (_typeof(dataItem) !== 'object') {
            item = dataItem.toString();
          } else {
            item = dataItem;
          }

          if (item === valueItem || item[valueFieldName] === valueItem) {
            if (multiple) {
              valueData.push(dataItem);
            } else {
              valueData = dataItem;
            }
          }

          return item;
        });
        return valueItem;
      }); // 根据数据看看是否要展开

      if (value && data.length) {
        _this.handleOpen(event, true, value);
      } else {
        _this.handleOpen(event, false);
      }

      if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, value, valueData);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (event, value, _valueData) {
      var isKeyPress = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var _compactProps2 = (0, _autocomplete_compact_props["default"])(_this.props),
          data = _compactProps2.data,
          multiple = _compactProps2.multiple,
          onSelect = _compactProps2.onSelect,
          delimiter = _compactProps2.delimiter,
          _compactProps2$fieldN = _compactProps2.fieldNames,
          fieldNames = _compactProps2$fieldN === void 0 ? {} : _compactProps2$fieldN;

      var _fieldNames$valueFiel2 = fieldNames.valueFieldName,
          valueFieldName = _fieldNames$valueFiel2 === void 0 ? 'value' : _fieldNames$valueFiel2,
          _fieldNames$labelFiel = fieldNames.labelFieldName,
          labelFieldName = _fieldNames$labelFiel === void 0 ? 'label' : _fieldNames$labelFiel;

      var addDataForLabelAndValueData = function addDataForLabelAndValueData() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var itemData = config.data;
        var itemLabel = config.label || '';

        if (multiple) {
          valueData.push(itemData);
          label.push(itemLabel);
        } else {
          valueData = itemData;
          label = itemLabel;
        }
      };

      var label = [],
          valueData = []; // 输入框失焦

      _this.inputRef && _this.inputRef.blur(); // 遍历下选中的数据获得“选中数据映射”与“文案”

      ((0, _spauiUtils.isArray)(value) ? value : [value]).map(function (valueItem) {
        data.map(function (item) {
          if (item === valueItem || item[valueFieldName] === valueItem) {
            addDataForLabelAndValueData({
              data: item,
              label: item[labelFieldName] || item || ''
            });
          }

          return item;
        });
        return valueItem;
      }); // 如果是回车选中大，要触发一下回车函数

      if (isKeyPress) {
        _this.handleKeyPress(event, (0, _spauiUtils.isArray)(label) ? label.join(delimiter) : label);
      }

      if ((0, _spauiUtils.isFunction)(onSelect)) {
        onSelect(event, value, label, valueData);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOpen", function (event, latestOpen, latestValue) {
      var _this$props = _this.props,
          onOpen = _this$props.onOpen,
          open = _this$props.open,
          propsValue = _this$props.value;
      var value = typeof latestValue !== 'undefined' ? latestValue : propsValue;
      var result = latestOpen; // 如果没传open，就自行判断

      if ((0, _spauiUtils.isUndefined)(open)) {
        // 没有数据就都是false
        if (!value) {
          result = false;
        }

        _this.setState({
          open: result
        });
      }

      if ((0, _spauiUtils.isFunction)(onOpen)) {
        onOpen(event, result);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (event, keyPressValue) {
      var _this$props2 = _this.props,
          onKeyPress = _this$props2.onKeyPress,
          value = _this$props2.value,
          delimiter = _this$props2.delimiter;
      var result = [],
          data = '';

      if ((0, _spauiUtils.isFunction)(onKeyPress)) {
        data = keyPressValue || value || '';

        if (data) {
          result = data.split(delimiter);
        }

        onKeyPress(event, result);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClear", function (event) {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          onClear = _this$props3.onClear;

      if ((0, _spauiUtils.isFunction)(onClear)) {
        onClear(event);
      } else if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, '');
      }

      event.stopPropagation();
    });

    _this.nullList();

    _this.state = {
      open: props.open || false
    };
    return _this;
  }

  _createClass(AutoComplete, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var focus = this.props.focus;
      var input = this.getInputNode(); // 聚焦

      if (focus && input) {
        input.focus();
      }

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _spauiUtils.isUndefined)(nextProps.open)) {
        this.setState({
          open: nextProps.open
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
    } // 声明以及一些引用的回收

  }, {
    key: "nullList",
    value: function nullList() {
      this.inputRef = null;
    } // 用于向实例提供内部node的节点引用

  }, {
    key: "getNode",
    value: function getNode() {
      return {
        input: this.getInputNode()
      };
    } // 用于向实例提供内部node的节点引用，标准应该用getNode，但是这个是getNode之前的，所以保留

  }, {
    key: "getInputNode",
    value: function getInputNode() {
      return this.inputRef || null;
    }
  }, {
    key: "getClassNameMap",
    value: function getClassNameMap() {
      var _this$props$className = this.props.classNameMap,
          classNameMap = _this$props$className === void 0 ? {} : _this$props$className;
      return _objectSpread({}, _classname_map["default"], classNameMap);
    } // 输入框变更回调

  }, {
    key: "getDataAndValueForSelect",
    // 为Select获取data, value
    value: function getDataAndValueForSelect() {
      var _this2 = this;

      var _compactProps3 = (0, _autocomplete_compact_props["default"])(this.props),
          _compactProps3$data = _compactProps3.data,
          data = _compactProps3$data === void 0 ? [] : _compactProps3$data,
          value = _compactProps3.value,
          multiple = _compactProps3.multiple,
          delimiter = _compactProps3.delimiter,
          convertPYs = _compactProps3.convertPYs,
          selectValue = _compactProps3.selectValue,
          emphasize = _compactProps3.emphasize,
          filter = _compactProps3.filter,
          html = _compactProps3.html,
          _compactProps3$fieldN = _compactProps3.fieldNames,
          fieldNames = _compactProps3$fieldN === void 0 ? {} : _compactProps3$fieldN;

      var result = {
        data: [],
        value: typeof selectValue !== 'undefined' ? selectValue : []
      };
      data.map(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        if (multiple || !filter || (0, _spauiUtils.isFunction)(filter) && filter(item, value, convertPYs, (0, _autocomplete_compact_props["default"])(_this2.props))) {
          (0, _push_data.pushDataToTarget)({
            target: result.data,
            data: item,
            by: function by() {
              return emphasize(item, {
                value: value,
                html: html,
                fieldNames: fieldNames
              });
            }
          });
        } // 如果没传选中的数据，就遍历下来获得选中的数据


        if (typeof selectValue === 'undefined') {
          if (multiple) {
            value.split(delimiter).map(function (subItem) {
              (0, _push_data.pushDataForSelect)({
                target: result.value,
                data: item,
                label: subItem,
                fieldNames: fieldNames
              });
              return subItem;
            });
          } else {
            (0, _push_data.pushDataForSelect)({
              target: result.value,
              data: item,
              label: value,
              fieldNames: fieldNames
            });
          }
        }

        return item;
      });
      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _compactProps4 = (0, _autocomplete_compact_props["default"])(this.props),
          clear = _compactProps4.clear,
          html = _compactProps4.html,
          onClickSearchIcon = _compactProps4.onClickSearchIcon,
          value = _compactProps4.value,
          placeholder = _compactProps4.placeholder,
          name = _compactProps4.name,
          disabled = _compactProps4.disabled,
          MoreDetailComponent = _compactProps4.MoreDetailComponent,
          multiple = _compactProps4.multiple,
          InputComponent = _compactProps4.InputComponent,
          focus = _compactProps4.focus,
          SelectProps = _compactProps4.SelectProps,
          ValueAreaComponent = _compactProps4.ValueAreaComponent,
          inputProps = _compactProps4.inputProps,
          _compactProps4$fieldN = _compactProps4.fieldNames,
          fieldNames = _compactProps4$fieldN === void 0 ? {} : _compactProps4$fieldN;

      var _fieldNames$valueFiel3 = fieldNames.valueFieldName,
          valueFieldName = _fieldNames$valueFiel3 === void 0 ? 'value' : _fieldNames$valueFiel3,
          _fieldNames$labelFiel2 = fieldNames.labelFieldName,
          labelFieldName = _fieldNames$labelFiel2 === void 0 ? 'label' : _fieldNames$labelFiel2;
      var open = this.state.open;
      var classNameMap = this.getClassNameMap();
      return _react["default"].createElement(_spauiSelect["default"], _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])(classNameMap.AutoComplete, 'has-icon', {
          'has-clear': clear
        })
      }, AutoComplete), this.getDataAndValueForSelect(), {
        classNameMap: classNameMap,
        valueFieldName: valueFieldName,
        labelFieldName: labelFieldName,
        multiple: multiple,
        htmlable: html,
        html: html,
        open: open,
        name: name,
        focus: focus,
        inputValue: value,
        placeholder: placeholder,
        disabled: disabled,
        ValueAreaComponent: ValueAreaComponent,
        MoreDetailComponent: MoreDetailComponent,
        onInputChange: this.handleChange,
        onChange: this.handleSelect,
        onOpen: this.handleOpen,
        onKeyPress: this.handleKeyPress,
        onClickSearchIcon: onClickSearchIcon,
        InputComponent: InputComponent,
        inputHtmlRef: function inputHtmlRef(el) {
          _this3.inputRef = el;
        },
        titleable: html ? false : true,
        onClear: this.handleClear,
        clearable: clear,
        clear: clear
      }, SelectProps, {
        inputProps: inputProps
      }));
    }
  }]);

  return AutoComplete;
}(_react.PureComponent); // 组件标记


_defineProperty(AutoComplete, "propTypes", _autocomplete_props.propTypes);

_defineProperty(AutoComplete, "defaultProps", _autocomplete_props.defaultProps);

(0, _spauiUtils.setComponentMark)(AutoComplete, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"]));
var _default = AutoComplete;
exports["default"] = _default;